import { BooleanInput } from '@angular/cdk/coercion';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { UserStorageService } from '#root/core/user/user.service';
import { User } from '#root/core/user/user.types';
import { Subject, takeUntil } from 'rxjs';

import { SettingsUserComponent } from './settings-user/settings-user.component';
import { FuseConfigService } from '@fuse/services/config';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user'
})
export class UserComponent implements OnInit, OnDestroy {

    public rol = localStorage.getItem('rol');

    /* eslint-disable @typescript-eslint/naming-convention */
    static readonly ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;

    private readonly _unsubscribeAll: Subject<any> = new Subject<any>();
    config: typeof this.fuseConfigurationService.config;

    /**
     * Constructor
     */
    constructor(
        private readonly _changeDetectorRef: ChangeDetectorRef,
        private readonly _router: Router,
        private readonly _userService: UserStorageService,
        private readonly _matDialog: MatDialog,
        public readonly fuseConfigurationService: FuseConfigService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        this.user = {
            id: localStorage.getItem('idUser'),
            name: localStorage.getItem('fullName'),
            email: localStorage.getItem('email'),
            avatar: localStorage.getItem('avatar'),
            status: 'Logueado'
        };

        this.fuseConfigurationService.config$.pipe(
            takeUntil(this._unsubscribeAll)
        )
            .subscribe((config) => {
                this.config = config;
                this._changeDetectorRef.markForCheck();
            });
    }

    setScheme(scheme: string): void {
        this.fuseConfigurationService.config = {scheme};
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
    }

    navigateToUserSettings(): void {
        this._router.navigate(['settings']);
    }

    public settings() {
        return this._matDialog.open(SettingsUserComponent, { width: "500px" })
    }
}
